import { render, staticRenderFns } from "./SalarieDetailIndex.vue?vue&type=template&id=17a94693&scoped=true"
import script from "./SalarieDetailIndex.vue?vue&type=script&lang=js"
export * from "./SalarieDetailIndex.vue?vue&type=script&lang=js"
import style0 from "./SalarieDetailIndex.vue?vue&type=style&index=0&id=17a94693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a94693",
  null
  
)

export default component.exports